<template>
  <v-carousel hide-delimiters show-arrows-on-hover class="hero-carousel">
    <v-carousel-item
      v-for="(item,i) in items"
      :key="i"
      :src="item.src"
    >
      <div class="d-flex flex-column justify-center align-center white--text fill-height">
        <div class="cal-sans-regular text-center" style="font-size: 8vw;">{{ item.title }}</div>
        <p class="outfit-regular text-center" style="font-size: 2.5vw;">{{ item.tagline }}</p>
      </div>
    </v-carousel-item>
  </v-carousel>
</template>

<script>
export default {
  name: 'Hero',
  data () {
    return {
      items: [
        {
          src: require('@/assets/hero-1.jpg'),
          title: 'Unleash Your Ideas',
          tagline: 'AI tools to bring your stories, games, and ideas to life',
        },
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
  .hero-carousel {
    border-radius: 10px;
    height: 30vw !important;
  }
  ::v-deep .v-image.v-responsive.v-carousel__item.theme--light {
    height: 30vw !important;
  }
</style>